var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcLeft({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8047 2.86225C11.0651 3.1226 11.0651 3.54471 10.8047 3.80506L6.60948 8.00033L10.8047 12.1956C11.0651 12.4559 11.0651 12.878 10.8047 13.1384C10.5444 13.3987 10.1223 13.3987 9.86193 13.1384L5.19526 8.47173C4.93491 8.21138 4.93491 7.78927 5.19526 7.52892L9.86193 2.86225C10.1223 2.6019 10.5444 2.6019 10.8047 2.86225Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLeft);
export default __webpack_public_path__ + "static/media/ic-left.73d0a58421e3dbc893e88ffbff08d47d.svg";
export { ForwardRef as ReactComponent };